import styled, { css } from 'styled-components'
import { absCenter } from '../../Styles/Mixins'

const SolidBtnStyle = css`
  border: 0 none;
  color: ${({ theme, color }) => color || theme.snow};
  background-color: ${({ theme, background }) => background || theme.primary};
`

const OutlineBtnStyle = css`
  padding: .6rem 1.8rem;
  border: 2px solid ${({ theme, color }) => color || theme.primary};
  color: ${({ theme, color }) => color || theme.primary};
  background-color: transparent;
`

const TextBtnStyle = css`
  border: 0 none;
  color: ${({ theme, color }) => color || theme.primary};
  background-color: transparent;
`

const DisabledBtnStyle = css`
  pointer-events: none;
  cursor: default;
  opacity: .5;
`

const FullWidthBtnStyle = css`
  width: 100%;
`

const ActiveBtnStyle = css`
  @media (hover: hover) {
    &:hover {
      opacity: 1;
    }
  }

  &:active,
  &:focus {
    outline: none;
    opacity: 1;
  }
`

const SmallButtonStyle = css`
  padding: .5rem 1rem;
`

const LargeButtonStyle = css`
  font-size: 1.8rem;
  line-height: 2;
`

const HoverIconBtnStyle = css`
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme, hoverBackground }) => hoverBackground || theme.border};
    }
  }
`

const IconBtnStyle = css`
  padding: 0;
  width: ${({ size }) => size || 50}px;
  height: ${({ size }) => size || 50}px;
  position: relative;
  color: ${({ theme, color }) => color || theme.primary};
  background-color: ${({ background }) => background || 'transparent'};
  border-radius: 50%;

  & svg {
    ${absCenter}
  }

  ${({ showHoverBg }) => showHoverBg && HoverIconBtnStyle}
`

export const Btn = styled.button`
  display: inline-block;
  padding: .8rem 2rem;
  user-select: none;
  text-align: center;
  white-space: nowrap;
  font-size: 1.4rem;
  font-weight: 400;
  border-radius: 4px;
  transition: all .2s;
  position: relative;
  overflow: hidden;
  line-height: 1.5;
  appearance: none;
  opacity: .85;

  /* Change for the <button> element */
  outline: none;
  border: none;
  cursor: pointer;



  /* Theme */
  ${SolidBtnStyle}
  ${({ text }) => text && TextBtnStyle}
  ${({ outline }) => outline && OutlineBtnStyle}
  ${({ fullWidth }) => fullWidth && FullWidthBtnStyle}
  ${({ processing }) => processing && DisabledBtnStyle}
  ${({ disabled }) => disabled && DisabledBtnStyle}

  /* Button Size */
  ${({ sm }) => sm && SmallButtonStyle}
  ${({ lg }) => lg && LargeButtonStyle}

  /* Icon button */
  ${({ icon }) => icon && IconBtnStyle}

  ${({ disabled, processing }) => (!disabled && !processing) && ActiveBtnStyle}
`

export const LoaderWrapper = styled.div`
  display: inline-block;
  vertical-align: -5px;
  margin-right: 5px;
`



// WEBPACK FOOTER //
// ./src/Components/Button/styles.js